// GoBack.jsx
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function GoBack({ to, text, color = "rgba(0,0,0,0.50)", icon }) {
    return (
        <Box
            component={RouterLink}
            to={to}
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                textDecoration: "none",
                color: color,
                "&:hover": { textDecoration: "underline" },
            }}
        >
            {icon || <ArrowBackIcon fontSize="small" />}
            <Typography
                sx={{
                    color: color,
                    /* Body 1 */
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "140 %", /* 22.4px */
                    letterSpacing: "0.5px"
                }}>
                {text}
            </Typography>
        </Box>
    );
}
